import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { getUserInfo, updateInfo } from "../../../API";
import { useSelector } from "react-redux";
import { scrollToTop, showLoding } from "../../../utils/tool";
import { message } from "antd";

const ComponentName: React.FC = () => {
  const { t } = useTranslation();
  const [see1, setSee1] = React.useState(true);
  const [see2, setSee2] = React.useState(true);
  const [see3, setSee3] = React.useState(true);

  const token = useSelector((state: any) => state?.token)
  useEffect(() => {
    if (!token) {
      return
    }
    handleUserInfo()
  }, [token]);

  const handleUserInfo = () => {
    getUserInfo().then((res) => {
      setName(res.data?.username)
      setPhone(res.data?.phone)
    }).catch((err) => {
    });
  }
  const [name, setName] = React.useState("");
  const [phone, setPhone] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [password2, setPassword2] = React.useState("");
  const [password3, setPassword3] = React.useState("");
  const handleSubmit = () => {
    showLoding(true);
    updateInfo({
      username: name,
      phone: phone,
      oldPassword: password,
      newPassword: password2,
      confirmNewPassword: password3,
    }).then((res) => {
      message.success("修改成功");
      handleUserInfo()
      scrollToTop()
    }).catch((err) => {
    }).finally(() => {
      showLoding(false);
    })
  }

  return (
    <div className="">
      <div>
        <div className="flex items-center mb-[20px] text-[#181512] text-[18px]">
          顯示名稱
          <div className="text-[red] text-[18px] ml-10">*</div>
        </div>
        <div className="flex ">
          <input type="text" className="flex-1 px-[15px] py-[10px] rounded-md outline-none text-[#181512] text-[18px]"
            value={name}
            onChange={(e) => setName(e.target.value)}
            style={{
              border: "1px solid #cfc8d8",
            }} />
        </div>
        <div className="text-[#595959] text-[14px] mb-[36px]">你的名稱在帳號區段和評論中看起來就像這樣</div>
      </div>
      <div>
        <div className="flex items-center mb-[20px] text-[#181512] text-[18px]">
          手機號碼
          <div className="text-[red] text-[18px] ml-10">*</div>
        </div>
        <div className="flex pb-[36px]">
          <input type="text" className="flex-1 px-[15px] py-[10px] rounded-md outline-none text-[#181512] text-[18px]"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            style={{
              border: "1px solid #cfc8d8",
            }} />
        </div>
      </div>
      <div className="text-[#181512] text-[28px] font-bold pb-20 mb-[30px]"
        style={{
          borderBottom: "1px solid #0003",
        }}>變更密碼</div>
      <div>
        <div className="flex items-center mb-[20px] text-[#181512] text-[18px]">
          目前的密碼(不需變更請留空)
          <div className="text-[red] text-[18px] ml-10">*</div>
        </div>
        <div className="flex items-center mb-[36px] pr-[15px] rounded-md"
          style={{
            border: "1px solid #cfc8d8",
          }} >
          <input type={`${see1 ? "password" : "text"}`}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="flex-1 px-[15px] py-[10px] rounded-md outline-none text-[#181512] text-[18px]" />
          <img src={
            see1 ? require("../../../assets/image/login/eye-close.png") :
              require("../../../assets/image/login/eye-see.png")}
            className="w-[22px] h-[22px] cursor-pointer ml-4"
            onClick={() => setSee1(!see1)}
            alt="" />
        </div>
      </div>
      <div>
        <div className="flex items-center mb-[20px] text-[#181512] text-[18px]">
          新密碼(不需變更請留空)
          <div className="text-[red] text-[18px] ml-10">*</div>
        </div>
        <div className="flex items-center mb-[36px] pr-[15px] rounded-md"
          style={{
            border: "1px solid #cfc8d8",
          }} >
          <input type={`${see2 ? "password" : "text"}`}
            value={password2}
            onChange={(e) => setPassword2(e.target.value)}
            className="flex-1 px-[15px] py-[10px] rounded-md outline-none text-[#181512] text-[18px]" />
          <img src={
            see2 ? require("../../../assets/image/login/eye-close.png") :
              require("../../../assets/image/login/eye-see.png")}
            className="w-[22px] h-[22px] cursor-pointer ml-4"
            onClick={() => setSee2(!see2)}
            alt="" />
        </div>
      </div>
      <div>
        <div className="flex items-center mb-[20px] text-[#181512] text-[18px]">
          確認新密碼
          <div className="text-[red] text-[18px] ml-10">*</div>
        </div>
        <div className="flex items-center mb-[36px] pr-[15px] rounded-md"
          style={{
            border: "1px solid #cfc8d8",
          }} >
          <input type={`${see3 ? "password" : "text"}`}
            value={password3}
            onChange={(e) => setPassword3(e.target.value)}
            className="flex-1 px-[15px] py-[10px] rounded-md outline-none text-[#181512] text-[18px]" />
          <img src={
            see3 ? require("../../../assets/image/login/eye-close.png") :
              require("../../../assets/image/login/eye-see.png")}
            className="w-[22px] h-[22px] cursor-pointer ml-4"
            onClick={() => setSee3(!see3)}
            alt="" />
        </div>
      </div>
      <div
        onClick={handleSubmit}
        className="bg-[#6d6e71] rounded-[4px] inline-block px-[50px] py-[16px] text-[#fff] text-[18px] cursor-pointer
                    hover:bg-[#000]">
        儲存設定
      </div>
    </div>
  );
};

export default ComponentName;
